<template>
    <v-layout>
        <v-flex class="scroll-y">
            <template v-if="showedTecnico == true">
                <v-layout>
                    <v-flex xs1 class="ml-2 py-2" style="cursor: pointer;" @click="showedTecnico = false">
                        <v-icon size="30">mdi-arrow-left</v-icon>
                    </v-flex>
                </v-layout>

                <v-layout row>
                    <v-flex xs1 style="min-width: 80px">
                        <avatar-input v-model="files.immagine_profilo" :preview="tecnico_mostrato.immagine_profilo"
                            size="65" />
                    </v-flex>

                    <v-flex xs12>
                        <text-field :label="$t('label.nome')" v-model="tecnico_mostrato.nome" required />
                    </v-flex>

                    <v-flex xs12>
                        <text-field :label="$t('label.cognome')" v-model="tecnico_mostrato.cognome" required />
                    </v-flex>
                </v-layout>

                <v-layout wrap class="pl-4 pt-1">
                    <v-flex xs12 sm6>
                        <text-field :label="$t('tecnici.label.username')" v-model="tecnico_mostrato.username"
                            prepend-icon="mail" required show-details :readonly="true" :disabled="true"
                            :v-rules="[$utils.rules.email]" />
                    </v-flex>

                    <v-flex xs12 sm6>
                        <phone-field :label="$t('label.telefono')" v-model="tecnico_mostrato.telefono" show-details />
                    </v-flex>
                </v-layout>

                <v-layout wrap class="d-flex align-center">
                    <v-flex xs12 sm6>
                        <image-input :label="$t('tecnici.label.scansione_firma')" class="ml-5"
                            v-model="files.scansione_firma"
                            :preview="tecnico_mostrato.username != null ? $api.tecnici.getFirmaUrl(tecnico_mostrato.id, null) : null"
                            :hint="$t('tecnici.label.scansione_firma_info')" required>

                            <template v-slot:error>
                                <v-icon color="grey">mdi-image-off</v-icon>
                            </template>

                        </image-input>
                    </v-flex>

                    <v-flex xs12 sm6>
                        <v-btn color="accent" round flat block @click="onStatsClick">{{ $t('tecnici.label.apri_stats')
                        }}</v-btn>
                        <v-btn color="warning" round flat block @click="onResetPKClick">{{
                            $t('tecnici.label.reset_product_key') }}</v-btn>
                    </v-flex>
                </v-layout>
            </template>

            <data-table v-else :items="showDeleted ? tecnici_disactive : tecnici_active" :headers="[
                { text: $t('label.nome_cognome'), value: 'nome', sortable: true },
                { text: $t('label.email'), value: 'username', sortable: true },
                { text: $t('label.telefono'), value: 'telefono' },
                { text: $t('label.report_compilati'), value: 'numero_report', sortable: true }]" :width-auto="true"
                initial-sort="nome" :loading="loading" show-header-button :toggled.sync="showDeleted"
                @click:item="(tecnico) => (showDeleted ? showDeletedDialog(tecnico) : showEditDialog(tecnico))">

                <template slot="items" slot-scope="{item}">
                    <td>
                        <v-avatar size="36px" color="#757575" class="my-2 mr-1">
                            <v-img v-if="item.immagine_profilo" :src="item.immagine_profilo"
                                @error="item.immagine_profilo = null" />
                            <v-icon v-else color="white">person</v-icon>
                        </v-avatar>
                        {{ item.nome }} {{ item.cognome }}
                    </td>
                    <td>{{ item.username }}</td>
                    <td>{{ $utils.formatPhone(item.telefono) }}</td>
                    <td>{{ item.numero_report }}</td>
                    <td>
                        <v-btn v-show="!showDeleted" icon small flat class="right"
                            @click.stop="showDeleteConfirmDialog(item.id)">
                            <v-icon>clear</v-icon>
                        </v-btn>
                    </td>
                </template>
            </data-table>

            <data-table v-if="showedTecnico == true"
                :headers="[
                    { text: $t('label.numero_attestato'), value: 'numero', width: 14 },
                    { text: $t('label.data'), value: 'data_controllo', width: 14 },
                    { text: $t('prenotazioni.label.marca'), value: 'marca', width: 16 },
                    { text: $t('prenotazioni.label.modello'), value: 'modello', width: 14 },
                    { text: $t('prenotazioni.label.telaio'), value: 'numero_serie', width: 14 },
                    { text: $t('prenotazioni.label.scadenza'), value: 'scadenza', width: 14 },
                    { text: $t('label.tecnico'), value: 'id_tecnico', width: 14 }]" :width-auto="true"
                :items="reports" :loading="loading" @click:item="showReportDialog">

                <template slot="items" slot-scope="{ item }">
                    <td>
                        <v-tooltip bottom>
                            <v-icon slot="activator" :color="item.compilato ? 'success' : 'error'">{{ item.compilato ?
                                'check_circle' : 'error' }}</v-icon>
                            <span>{{ item.compilato ? $t('reports.messaggi.compilato') :
                                $t('reports.messaggi.non_compilato') }}</span>
                        </v-tooltip>
                        <span class="ml-2" style="vertical-align: text-bottom">{{ item.numero }}</span>
                    </td>
                    <td>{{ $d($utils.date.toJs(item.data_controllo)) }}</td>
                    <td>{{ item.marca }}</td>
                    <td>{{ item.modello }}</td>
                    <td>{{ item.numero_serie }}</td>
                    <td>{{ item.scadenza }}</td>
                    <td colspan="2">{{ getNomeCognomeById(item.id_tecnico) || "-" }}</td>
                </template>
            </data-table>

            <v-btn v-show="!showDeleted" @click="showedTecnico ? editTecnico() : showCreateDialog()" color="accent"
                fixed right bottom round large class="mr-2">
                <div v-if="showedTecnico == false" class="d-flex align-center">
                    <v-icon class="mr-2">add</v-icon>
                    {{ $t('azioni.aggiungi') }}
                </div>
                <span v-else>{{ $t('tecnici.azioni.modifica') }}</span>
            </v-btn>

            <report-dialog ref="reportDialog" />
            <tecnico-dialog ref="tecnicoDialog" @success="fetchData" @click:stats="showStatsDialog" />
            <tecnico-deleted-dialog ref="tecnicoDeletedDialog" @success="fetchData" />
            <tecnico-stats-dialog ref="tecnicoStatsDialog" />

        </v-flex>
    </v-layout>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import TecnicoDialog from '@/components/TecnicoDialog'
import TecnicoDeletedDialog from '@/components/TecnicoDeletedDialog'
import TecnicoStatsDialog from '@/components/TecnicoStatsDialog'
import ReportDialog from '@/components/ReportDialog'
import { AvatarInput, ImageInput, PhoneField } from '../../src/components/inputs'

export default {
    name: 'Tecnici',
    components: { DataTable, TecnicoDialog, TecnicoDeletedDialog, TecnicoStatsDialog, ReportDialog, AvatarInput, ImageInput, PhoneField },
    data: () => ({
        showDeleted: false,
        loading: false,
        tecnici_active: [],
        tecnici_disactive: [],
        reports: [],
        showedTecnico: false,
        tecnico_mostrato: {
            schemi: [],
        },
        files: {
            immagine_profilo: null,
            scansione_firma: null
        }
    }),
    watch: {
        showDeleted: {
            handler: 'fetchData',
            immediate: true
        }
    },
    mounted() {
        //  Per evitare errori prima carico i dati dei tecnici
        this.loading = true
        Promise.all([
            this.$store.dispatch('loadTecnici')
        ]).then(() => {
            this.fetchData(1)
        }).catch(e => {
            this.$snackbar.showServerError(e)
            this.loading = false
        })
    },
    methods: {
        showCreateDialog() {
            this.$refs.tecnicoDialog.showCreate()
        },
        async showEditDialog(tecnico) {
            this.tecnico_mostrato = JSON.parse(JSON.stringify(tecnico));
            await this.$api.reports.get({ tecnico: tecnico.username })
                .then((res) => {
                    this.showedTecnico = true;
                    this.reports = res.data;
                }).catch(e => {
                    console.log("showEditDialog")
                    if (e.response && e.response.status === 404 && e.response.data.message === 'in use') {
                        this.$snackbar.show(this.$t('unita_mobili.errori.riferimenti_attivi'), 'error')
                    } else {
                        this.$snackbar.showServerError(e)
                    }
                })
        },
        editTecnico() {
            if (this.tecnico_mostrato.nome != "" && this.tecnico_mostrato.cognome != "") {
                let formData = new FormData();

                // aggiungi i campi di tecnico_mostrato
                Object.keys(this.tecnico_mostrato).forEach(key => {
                    formData.append(key, this.tecnico_mostrato[key]);
                });

                // aggiungi il file
                if (this.files && this.files.scansione_firma) {
                    formData.append('scansione_firma', this.files.scansione_firma);
                }

                this.$api.tecnici.update(this.tecnico_mostrato.id, formData).then(() => {
                    this.fetchData();
                    this.showedTecnico = false;
                    this.$snackbar.show(this.$t('tecnici.messaggi.modificato'), 'success');
                }).catch(e => {
                    this.$snackbar.showServerError(e);
                });
            }
        },
        showDeletedDialog(tecnico) {
            this.$refs.tecnicoDeletedDialog.show(tecnico)
        },
        showStatsDialog(tecnico) {
            this.$refs.tecnicoStatsDialog.show(tecnico)
        },
        showDeleteConfirmDialog(id) {
            this.$confirmDialog.show({ id: id, fetchFunction: this.fetchData }, this.$t('messaggi.conferma_eliminazione'), this.deleteTecnico)
        },
        deleteTecnico(obj) {
            console.log("eliminazione tecnico", obj.id)
            this.$api.tecnici.disactiveTecnico(obj.id)
                .then(() => {
                    this.$snackbar.show(this.$t('tecnici.messaggi.eliminato'), 'success')
                    obj.fetchFunction()
                }).catch(e => {
                    if (e.response && e.response.status === 404 && e.response.data.message === 'in use') {
                        this.$snackbar.show(this.$t('tecnici.errori.errore_eliminato'), 'error')
                    } else {
                        this.$snackbar.showServerError(e)
                    }
                })
        },
        showReportDialog(report) {
            this.$refs.reportDialog.show(report, null, true);
        },
        onStatsClick() {
            this.showStatsDialog(this.tecnico_mostrato);
        },
        onResetPKClick() {
            this.$confirmDialog.show(
                this.tecnico_mostrato.username,
                this.$t('tecnici.messaggi.conferma_reset_product_key'),
                (username) => {
                    this.$api.tecnici.resetProductKey(username).then(() => {
                        this.onSuccess(this.$t('tecnici.messaggi.reset_product_key'))
                    }).catch(e => {
                        this.onError()
                    })
                }, { color: 'warning' })
        },
        getNomeCognomeById(id) {
            let tecnico = this.$store.getters.getTecnicoById(id);
            return tecnico ? tecnico.nome_cognome : '-';
        },
        action() {
            if (this.showDeleted) {
                return this.$api.tecnici.getDeleted()
            } else {
                return this.$api.tecnici.getAll()
            }
        },
        fetchData() {
            this.loading = true
            this.action()
                .then(response => {
                    this.loading = false
                    this.tecnici_active = [];
                    this.tecnici_disactive = [];
                    for (let t of response.data) {
                        if (t.attivo) {
                            this.tecnici_active.push(t);
                        } else {
                            this.tecnici_disactive.push(t);
                        }
                    }
                    console.log("this.tecnici_active", this.tecnici_active)
                    // Viene forzato l'aggiornamento per i select tecnico
                    this.$store.commit('SET_TECNICI', [])
                }).catch(e => {
                    this.$snackbar.showServerError(e)
                    this.loading = false
                })
        }
    }
}
</script>
